<template>
  <div class="pro">
    <div class="scrollButton">
        <i class="zmdi zmdi-long-arrow-down" />
        <small>Scrollez vers le bas pour voir +</small>
    </div>
    <div class="pro-hero">
        <div class="pro-hero-info">
            <img class="pro-hero-info-logo" src="../assets/LOGO_TAUR-WHITE-TRANSPARENT.png" />
            <strong class="pro-hero-info-title work-sans">
                Dernier single <br /> "Holler"
            </strong>
            <span class="pro-hero-info-subtitle">
                Plus de 50.000 streams <br /> en une semaine sur <img src="../assets/Spotify_Logo_RGB_White1.png" />
            </span>
            <strong class="pro-hero-info-title second work-sans">
                Premier album <br /> "Half Somewhere"
            </strong>
            <span class="pro-hero-info-subtitle">
                Sortie le 7 Mai 2021 <br />
            </span>
        </div>
        <Player />
        <div class="taur-picture">
            <img src="../assets/CAPTURE_TAUR_121.jpg" />
        </div>
    </div>

    <div class="pro-imagebanner">
        <img src="../assets/BANNER_IMAGES1.png" alt="">
    </div>

    <div class="pro-magazine pro-magazine-image-left">
        <img src="../assets/CAPTURE_TAUR_377.jpg" />
        <div class="pro-magazine-text">
            <strong class="pro-magazine-title work-sans">
                Compositeur, producteur, et réalisateur
            </strong>
            <p>
                Le rennais Mathieu Artu (anagramme de TAUR) a sorti 3 EP, dont le dernier, éponyme, chez Pop Records / Polydor.
            </p>
            <p>
                Un opus à la production acérée qui navigue entre une pop radiophonique presque mathématique, des superpositions de nappes brutes et nocturnes, et des textes à fleur de peau. Sa musique « de haute voltige, proche du groove mélancolique de Chet Faker » selon les Inrockuptibles, est mise en scène par les clips hypnotiques qui accompagnent chacun des titres, et qu'il réalise lui même.
            </p>
            <div class="logos">
                <img class="pop" src="../assets/poprecords.png" />
                <img class="polydor" src="../assets/polydor.png" />
            </div>
        </div>
    </div>

    <div class="pro-videobanner">
        <video src="../assets/live/holler.webm" autoplay="autoplay" muted loop />
    </div>

    <div class="pro-magazine pro-magazine-image-right">
        <img src="../assets/CAPTURE_TAUR_612_carre.jpg" />
        <div class="pro-magazine-text red">
            <strong class="pro-magazine-title work-sans">
                Premier album
            </strong>
            <p>
                'Holler', premier single extrait de l'album, est sorti le 29.01.2021 et dépasse les 50.000 streams en une semaine.      
            </p>
            <p>
                ‘Cowards’, le précédent titre de TAUR (plus d'un million de streams sur les plates-formes), paraphrase la notion de paralysie relationnelle au travers d’une fresque fraternelle, colorée et frissonnante.  <br />
            </p>
            <p>
                L’ambivalence des sentiments, la dissonance des émotions comme exutoire, c’est l’essence même de ce qui fait la singularité de TAUR, qui puise son inspiration dans les musiques de films des 80’s et dépasse largement les attentes d’un univers pop décliné à l’infini.            
            </p>
            <p>
                Son premier album est attendu pour le 7 Mai 2021.
            </p>
        </div>
    </div>

    <!-- <div class="pro-titlebanner">
        <strong class="pro-titlebanner-title work-sans">Live sessions</strong>
        <p>
            En octobre 2020, TAUR enregistre 3 live sessions aux locaux de BETC à Paris, accompagné de ses musiciens Diego Chappedelaine (batterie) et Arno Monni (guitare / basse).
            <br/>
            Merci de ne pas partager ces sessions, qui seront diffusées publiquement ultérieurement.
        </p>
    </div>

    <div class="pro-youtube-section">
        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/5nHhgZEHg68" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <strong class="work-sans">Holler</strong>
    </div>
    <div class="pro-youtube-section">
        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/PTxYxV_ESMw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <strong class="work-sans">The Man That You Were</strong>
    </div>
    <div class="pro-youtube-section">
        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/0_gWsVKDzpg" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <strong class="work-sans">Strong</strong>
    </div> -->

    <div class="pro-hero40">
        <div class="pro-hero40-info">
            <strong class="pro-hero40-info-title work-sans">Projet 40</strong>
            <p>
                En 2020, TAUR est d'abord à l'initiative, puis chef d'orchestre et participant, du projet 40, réunissant
                56 artistes comme Malik Djoudi, Naive New Beaters, Clou, LAAKE, Canine, Inüit - pour la création d’un album collaboratif au profit de la fondation HP-HF.
            </p>
            <img src="../assets/photos40.png" />
        </div>
        <img src="../assets/TAUR_BANNER_SOCIAL_YOUTUBE.jpg" />
    </div>

    <div class="pro-imagebanner">
        <img src="../assets/BANNER_IMAGES2.png" alt="">
    </div>

    <div class="pro-magazine pro-magazine-image-right">
        <img src="../assets/taur-sequential.png" />
        <div class="pro-magazine-text">
            <strong class="pro-magazine-title work-sans">
                En studio
            </strong>
            <p>
                TAUR collabore en studio avec Pierrick Devin (Phoenix, Lomepal, Radio Elvis...) ainsi que Alex Gopher (Mr. Oizo, Nekfeu, Eddy De Pretto, Lomepal...).
            </p>
        </div>
    </div>

    <div class="pro-magazine pro-magazine-image-left">
        <img src="../assets/taur-live2.png" />
        <div class="pro-magazine-text grey">
            <strong class="pro-magazine-title work-sans">
                En live
            </strong>
            <p>
                TAUR est accompagné en live de Diego Chappedelaine (batterie) et de Arno Monni (guitare / basse).
            </p>
            <p>
                Ils ont travaillé 4 ans ensemble afin de créer un setup complètement autonome, facile à déplacer tant en showcase qu’en festival.
            </p>
            <p>
                Ils utilisent leur propre système de retour in-ear et fournissent 12 XLR prêts à patcher. <br /> (Fiche technique à disposition sur demande)
            </p>
        </div>
    </div>

    <div class="pro-titlebanner">
        <strong class="pro-titlebanner-title work-sans">Biographie</strong>
        <p>
            Version longue : <a href="/TAUR_Biographie_longue.pdf">télécharger le pdf</a> <br /><br />
            Version courte : <a href="/TAUR_Biographie_courte.pdf">télécharger le pdf</a><br /><br />
        </p>
        <strong class="pro-titlebanner-title work-sans">Contacts</strong>
        <p>
            <strong>Polydor</strong> <br/><br/>
            Radio : Nathalie.scholtes@umusic.com / celine.gauchery@umusic.com <br/>
            Presse : tania.scemama@umusic.com <br/>
            TV : jocelyn.chapel@umusic.com / charlotte.trillot@umusic.com <br/>
            Web : nina.veyrier@umusic.com <br/>
        </p>
        <p>
            <strong>Pop Records</strong><br/><br/> Christophe Caurret
        </p>
        <p>
            <strong>Editions</strong><br/><br/> Fabrice Benoit &amp; Fredéric Monvoisin
        </p>
        <p>
            <strong>TAUR</strong><br/><br/> @taurofficial
        </p>
    </div>
    
            

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Player from '../components/Player.vue'

export default defineComponent({
    name: 'ProPage',
    components: {
        Player,
    },
    beforeCreate() {
        const password = prompt('Please enter the password to continue')
        if (password !== 'TAUR2021') {
            return this.$router.push('/')
        }
    }
})
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Work+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');


body {
    overflow-x: hidden;
}

.pro {
    $pageBackground: #000;
    background: $pageBackground;
    overflow: hidden;
    width: 100vw;
    color: white;
    font-family: 'Lato';
    font-size: 18px;

    .scrollButton {
        position: absolute;
        right: 50px;
        bottom: 50px;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        @media screen and (max-width: 1200px) {
            right: auto;
            left: 50%;
            transform: translateX(-50%);
        }

        @media screen and (max-width: 600px) {
           display: none;
        }

        i {
            width: 70px;
            height: 70px;
            margin-bottom: 10px;
            background: rgba(255,255,255,0.2);
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .work-sans {
        font-family: 'Work Sans';
        text-transform: uppercase;
        font-weight: 600;
    }

    &-hero {
        width: 100%;
        height: 100vh;
        max-height: 100vh;
        overflow: hidden;
        position: relative;
        background: rgba(208,206,217,1);

        .Player {
            position: absolute;
            top: 550px;
            left: 10%;
            z-index: 1000;

            @media screen and (max-width: 1200px) {
                right: auto;
                left: 50%;
                transform: translateX(-50%);
            }

            @media screen and (max-width: 600px) {
                top: 430px;
            }

            @media screen and (max-height: 800px) {
                top: 430px;
            }
        }

        .taur-picture {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            height: 100vh;

            @media screen and (max-width: 1200px) {
                opacity: 1;
            }

            img {
                height: 100vh;
                width: 100vw;
                object-fit: cover;
            }
        }


        &-info {
            position: absolute;
            z-index: 2;
            top: 150px;
            left: 10%;
            display: flex;
            flex-direction: column;
            align-items: center;

            @media screen and (max-height: 800px) {
                top: 30px;
            }

            @media screen and (max-width: 1200px) {
                right: auto;
                left: 50%;
                transform: translateX(-50%);
            }

            @media screen and (max-width: 600px) {
                top: 80px;
                width: 80%;
                text-shadow: 0 1px 5px rgba(0,0,0,0.5);
            }

            &-logo {
                width: 250px;
                margin-bottom: 20px;

                @media screen and (max-width: 600px) {
                    width: 200px;
                    margin-bottom: 50px;
                }
            }

            &-title {
                font-size: 25px;
                margin-bottom: 20px;

                @media screen and (max-width: 600px) {
                    font-size: 20px;
                }

                @media screen and (max-width: 600px) {
                    margin-bottom: 10px;
                }

                &.second {
                    margin-top: 80px;

                    @media screen and (max-height: 800px) {
                        margin-top: 10px;
                    }

                    @media screen and (max-width: 600px) {
                        margin-top: 50px;
                    }
                }
            }

            &-subtitle {
                display: flex;
                align-items: center;

                @media screen and (max-width: 600px) {
                    font-size: 14px;
                }

                img {
                    margin-left: 20px;

                    @media screen and (max-width: 600px) {
                        width: 30%;
                    }
                }
            }

        }
    }

    &-imagebanner {
        width: 100%;
        overflow: hidden;

        img {
            display: block;
            max-height: 500px;
            object-fit: cover;
            object-position: top;
            width: 100%;
        }
    }

    &-magazine {
        display: flex;
        max-height: 100vh;
        overflow: hidden;

        @media screen and (max-width: 1200px) {
            flex-direction: column;
            max-height: 100%;
        }

        &-image-right img {
            order: 1;

            @media screen and (max-width: 1200px) {
                order: 0;
            }
        }

        & > img {
            display: flex;
            flex: 1;
            width: 50%;
            object-fit: cover;

            @media screen and (max-width: 1200px) {
                width: 100%;
            }
        }

        &-text {
            display: flex;
            box-sizing: border-box;
            padding: 100px 100px;
            flex-direction: column;
            justify-content: center;
            width: 50%;
            text-align: left;
            background: white;
            color: black;

            @media screen and (max-width: 1200px) {
                width: 100%;
                flex: 1;
                padding: 100px 50px;
            }

            &.grey {
                color: white;
                background: #232323;
            }

            &.red {
                color: white;
                background: #680d0d;
            }

            img {
                margin-top: 40px;
                margin-right: 20px;
            }
        }

        &-title {
            font-size: 30px;
            margin-bottom: 60px;
        }

        .logos {
            .pop {
                position: relative;
                top: 5px;
            }

            .gum {
                margin-left: 5px;
            }
        }
    }

    &-videobanner {
        @media screen and (max-width: 1200px) {
            display: none;
        }
        video {
            display: block;
            width: 100%;
            max-height: 500px;
            object-fit: cover;
        }
    }

    &-titlebanner {
        padding: 100px 200px;
        text-align: left;
        background: white;
        color: black;

        strong {
            font-size: 22px;
        }

        p strong {
            font-size: inherit;
        }

        @media screen and (max-width: 1200px) {
            padding: 100px 50px;
        }

        a {
            color: red;
            text-decoration: underline;
        }
    }

    &-youtube-section {
        iframe {
            display: block;
            width: 100%;
            height: 800px;
        }
        strong {
            display: flex;
            font-size: 22px;
            color: white;
            background: #232323;
            justify-content: center;
            align-items: center;
            padding: 50px 200px;

            @media screen and (max-width: 1200px) {
                padding: 50px;
            }
            
        }
    }

    &-hero40 {
        position: relative;
        max-height: 100vh;
        overflow: hidden;

        & > img {
            display: block;
            width: 100%;
            object-fit: cover;
        }

        &-info {
            top: 200px;
            right: 0;
            text-align: left;
            position: absolute;
            color: #fff;

            @media screen and (max-width: 1200px) {
                top: 50px;
                left: 50px;
                right: auto;

            }

            img {
                position: absolute;
                right: 0;
                width: 100%;

                @media screen and (max-width: 1200px) {
                    display: none;
                }
            }

            strong,
            p {
                width: 400px;
                margin-right: 300px;

                @media screen and (max-width: 1200px) {
                    width: 200px;
                }
            }

            strong {
                font-size: 22px;
                display: block;
                margin-bottom: 30px;
            }

            
        }
    }

    
}
</style>